export const CAPEX_API_ERRORS = {
  PAST_DATE: 'Excel Main sheet date is in the past',
} as const

export const CAPEX_ERROR_KEYS = {
  PAST_DATE: 'past-date-error',
} as const
